import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { ExpansionPanel, ExpansionPanelActionEvent } from '@progress/kendo-react-layout';
import { useEffect, useRef, useState } from 'react';
import SweetAlertService from '../../../services/SweetAlertService';
import { backDatedDateReport, defaultEmployerForReport, errorMessagesForReoprt, getRequiredErrorMessage, rangeOfStartAndEndDateCount, titleForAverageWeek, titleForDutyOnCallPeriods, titleForOverview, titleForSetTargets, titleForWeeklyBreakdown } from '../../admin/Shared/Constants/AdminModuleConstants';
import ReportService from '../Services/ReportService';
import WorkActivityService from '../Services/WorkActivityService';
import { AverageWeek } from './AverageWeek';
import { DutyOncall } from './DutyOncall';
import './Index.css';
import { OverView } from './OverView';
import { SetTarget } from './SetTarget';
import { WeeklyBreakDown } from './WeeklyBreakDown';
import { Calendar, CalendarCell, } from '@progress/kendo-react-dateinputs';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Switch } from "@progress/kendo-react-inputs";
import moment from 'moment';
import { OverViewPdf } from './ExportPdf/OverViewPdf';
import { WeeklyBreakDownPdf } from './ExportPdf/WeeklyBreakDownPdf';
import { AverageWeekPdf } from './ExportPdf/AverageWeekPdf';
import { drawDOM, Group, pdf } from '@progress/kendo-drawing';
import { useAuth } from '../../../providers/AuthProvider';
import { Spinner } from 'react-bootstrap';
import { AppConstants, EmployerNamePattern } from '../Shared/Constants/AppConstant';
import { SubRoleType } from '../../../utils/SubRoleConstants';

export const Report = () => {
    //To set default start date
    const setDefaultStartDate = (currentDate: any) => {
        let backDatedDate = new Date(currentDate.setDate(currentDate.getDate() - backDatedDateReport));
        let startDate: any;
        // To check 30 days back form current date is monday or not
        if (new Date(backDatedDate).getDay() == 1) {
            startDate = backDatedDate;
        } else {
            let isSunday = new Date(backDatedDate).getDay() == 0;
            startDate = new Date(backDatedDate.setDate(backDatedDate.getDate() - backDatedDate.getDay() + 1 - (isSunday ? 7 : 0)));
        }
        return startDate;
    }

    //To set default end date
    const setDefaultEndDate = (currentDate: any) => {
        let endtDate: any;
        if (new Date(currentDate).getDay() == 0) {
            endtDate = currentDate;
        } else {
            endtDate = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 7));
        }
        return endtDate;
    }
    const [employerList, setEmployerList] = useState<any>([]);
    const [selectedEmployer, setSelectedEmployer] = useState<any>({ value: { id: 0, employerName: defaultEmployerForReport } });
    const [formState, setFormState] = useState({ startDate: setDefaultStartDate(new Date()), endDate: setDefaultEndDate(new Date()), employerId: 0 });
    const [errorMessages, setErrorMessage] = useState({ emplyer: "", startDate: "", endDate: "" });
    const [isReportDataExist, setIsReportDataExist] = useState(false);
    const [isReportDataNotExist, setIsReportDataNotExist] = useState(false);
    const [userDefinedCategoryName, setUserDefinedCategoryName] = useState("");
    const [dutyOnCallActivityExist, setDutyOnCallActivityExist] = useState(false)
    const [isDutyOnCallCategoryExist, setIsDutyOnCallCategoryExist] = useState(false);
    const [employerId, setEmployerId] = useState(0);

    const [overViewDonutChartData, setOverViewDonutChartData] = useState<any>({ categories: [], subCategories: [], totalHours: 0, totalMinutes: 0, totalNumberOfWeeks: 0, lineChartData: [] });
    const [averageWeekDonutChartData, setAverageWeekDonutChartData] = useState<any>(
        {
            categories: [], subCategories: [], totalHours: 0, totalMinutes: 0,
            totalSessions: 0, dccExceedsContracted: 0, iccDccExceedsContracted: 0,
            iccPercentage: 0, contractPercentage: 0, aggregateContractPercentage: 0,
            aggregateIccDccPercentage: 0, isPublicHolidayToggelChecked: false, isLeaveToggelChecked: false
        }
    );
    const [weeklyBreakdownData, setWeeklyBreakdownData] = useState<any>({
        weeklyBreakDownDetails: [],
        totalNumberOfWeeks: 0,
        isLeaveToggleChecked: false,
        isPublicHolidayToggleChecked: false
    });

    const [validCategoryIds, setValidCategoryIds] = useState<number[]>([]);
    const [reportSubRoleId, setReportSubRoleId] = useState<number>(0);

    const getJobCategories = (subRoleId: number) => {
        WorkActivityService.getWorkActivityCategories(subRoleId).then((response) => {
            if (response?.data) {
                let categoryIds = response?.data.map((x: any) => x.jobCategoryId);
                setValidCategoryIds(categoryIds);
                setReportSubRoleId(subRoleId);
            }
        }).catch(() => {
            SweetAlertService.error("Error", "Something went wrong while getting job categories");
        });
    }

    const [anySetTargetExists, setAnySetTargetExists] = useState<any>(false);

    const setWeeklyBreakDownData = (weeklyBreakdownData: any) => {
        setWeeklyBreakdownData({
            weeklyBreakDownDetails: weeklyBreakdownData.weeklyBreakDownDetails, totalNumberOfWeeks: weeklyBreakdownData.totalNumberOfWeeks,
            isLeaveToggleChecked: weeklyBreakdownData.isLeaveToggleChecked, isPublicHolidayToggleChecked: weeklyBreakdownData.isPublicHolidayToggleChecked
        });
    }
    const setOverViewData = (overViewDonutChartData: any) => {
        setOverViewDonutChartData({
            categories: overViewDonutChartData.categories,
            subCategories: overViewDonutChartData.subCategories,
            totalHours: overViewDonutChartData.totalHours,
            totalMinutes: overViewDonutChartData.totalMinutes,
            totalNumberOfWeeks: overViewDonutChartData.totalNumberOfWeeks,
            lineChartData: overViewDonutChartData.lineChartData,
            isPublicHolidayToggelChecked: overViewDonutChartData.isPublicHolidayToggelChecked,
            isLeaveToggelChecked: overViewDonutChartData.isLeaveToggelChecked,
            weekRange: overViewDonutChartData.weekRange
        });
    }

    const setAverageWeekData = (averageWeekDonutChartData: any) => {
        setAverageWeekDonutChartData(
            {
                categories: averageWeekDonutChartData.categories, subCategories: averageWeekDonutChartData.subCategories, totalHours: averageWeekDonutChartData.totalHours, totalMinutes: averageWeekDonutChartData.totalMinutes,
                totalSessions: averageWeekDonutChartData.totalSessions, dccExceedsContracted: averageWeekDonutChartData.dccExceedsContracted, iccDccExceedsContracted: averageWeekDonutChartData.iccDccExceedsContracted,
                iccPercentage: averageWeekDonutChartData.iccPercentage, contractPercentage: averageWeekDonutChartData.contractPercentage, aggregateContractPercentage: averageWeekDonutChartData.aggregateContractPercentage,
                aggregateIccDccPercentage: averageWeekDonutChartData.aggregateIccDccPercentage,
                isPublicHolidayToggelChecked: averageWeekDonutChartData.isPublicHolidayToggelChecked,
                isLeaveToggelChecked: averageWeekDonutChartData.isLeaveToggelChecked,
            }
        );
    }

    const setTargetData = (anySetTargetExists: any) => {
        setAnySetTargetExists(anySetTargetExists);
    }

    useEffect(() => {
        //To disable keyboard, mouse event for start date and end date pickers
        const element = document.querySelectorAll('.k-datepicker input');
        if (element) {
            element.forEach(x => {
                x.addEventListener('wheel', function (event) {
                    event.stopImmediatePropagation();
                });
                x.addEventListener('keydown', function (event) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                });
            });
        }
        //To keep datetime in local format
        Date.prototype.toJSON = function () { return moment(this).format(); }
        //To get all employers to show in tht drop-down
        getAllEmployersForReport();
    }, []);

    const getAllEmployersForReport = () => {
        ReportService.getAllEmployersForReport().then((response) => {
            //set the employers list
            if (response.data) {
                if (response.data.length == 1) {
                    setEmployerList(response.data);
                    setSelectedEmployer({ value: response.data[0] });
                    setFormState({ ...formState, ['employerId']: response.data[0].id });
                    setEmployer(response.data[0].employerName);
                }
                else {
                    let multipleEmployerList: any[] = [];
                    multipleEmployerList.push(selectedEmployer.value);
                    response.data.map((res: any) => {
                        multipleEmployerList.push(res);
                    });
                    setEmployerList(multipleEmployerList);
                }
            }
        })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while getting employers");
            });
    }

    const checkingErrors = (employerId: any, startDate: any, endDate: any) => {
        let errors: any = { emplyer: "", startDate: "", endDate: "" };
        //To check employer is required
        if (employerId == 0) {
            errors.emplyer = errorMessagesForReoprt.employer;
        }
        //To check startDate is required
        if (!startDate) {
            errors.startDate = getRequiredErrorMessage("Start date");
        }
        //To check endDate is required
        if (!endDate) {
            errors.endDate = getRequiredErrorMessage("End date");
        }
        //To check endDate should be greater than startDatw
        if (startDate && endDate && (startDate >= endDate)) {
            errors.endDate = errorMessagesForReoprt.endDate;
        }
        //To check diffrence between start data and end date in weeks
        if (startDate && endDate && !errors.endDate) {
            let weekCount = Math.round((endDate - startDate) / (7 * 24 * 60 * 60 * 1000));
            if (weekCount > rangeOfStartAndEndDateCount) {
                errors.endDate = errorMessagesForReoprt.rangeOfStartAndEndDate;
            }
        }
        setErrorMessage(errors);
        if (!errors.emplyer && !errors.startDate && !errors.endDate) {
            return true;
        }
        return false;
    }

    const [showOverview, setshowOverview] = useState(true);
    const [showWeeklyBreakdown, setShowWeeklyBreakdown] = useState(false);
    const [showAverageWeek, setShowAverageWeek] = useState(false);
    const [showDutyOnCallPeriods, setshowDutyOnCallPeriods] = useState(false);
    const [showSetTargets, setshowSetTargets] = useState(false);

    //On change of employee from drop down
    const onEmplyerChange = (event: DropDownListChangeEvent) => {
        let name: any = event.target.name;
        setFormState({ ...formState, [name]: event.target.value.id });
        setSelectedEmployer({ value: event.target.value });
        setEmployer(event.target.value.employerName);
        checkingErrors(event.target.value.id, formState.startDate, formState.endDate);
    };

    //On change of start date
    const onStartDateChange = (event: any) => {
        //To disable today button changes in start date picker
        if (event.syntheticEvent.target.innerHTML == "TODAY") {
            event.syntheticEvent.preventDefault();
            return false;
        }
        let name: any = event.target.name;
        setFormState({ ...formState, [name]: event.target.value });
        checkingErrors(formState.employerId, event.target.value, formState.endDate);
    };

    //On change of end date
    const onEndDateChange = (event: any) => {
        //To disable today button changes in end date picker
        if (event.syntheticEvent.target.innerHTML == "TODAY") {
            event.syntheticEvent.preventDefault();
            return false;
        }
        let name: any = event.target.name;
        setFormState({ ...formState, [name]: event.target.value });
        checkingErrors(formState.employerId, formState.startDate, event.target.value);
    };

    //To get if report data exists or not and to get user-defined category name
    const CheckIfReportDataExists = (employerId: any, startDate: any, endDate: any, subRoleId: any) => {
        setEmployerId(employerId);
        setshowOverview(false);
        let payload: any = {};
        payload.startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0);
        payload.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59);
        setStartDate(payload.startDate);
        setEndDate(payload.endDate);
        payload.employerId = employerId;
        payload.subRoleId = subRoleId;
        ReportService.CheckIfReportDataExists(payload).then((response) => {
            if (response) {
                setIsReportDataExist(response.data.isActivityExist);
                setIsReportDataNotExist(!response.data.isActivityExist);
                setUserDefinedCategoryName(response.data.userDefinedCategoryName);
                setDutyOnCallActivityExist(response.data.isOnDutyExistForDCCAndICC)
                setIsDutyOnCallCategoryExist(response.data.isDutyOnCallActivityExist)
                setshowOverview(true);
                setShowWeeklyBreakdown(false);
                setShowAverageWeek(false);
                setshowDutyOnCallPeriods(false);
                setshowSetTargets(false);
            }
        })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while getting if report data exists or not");
            });
    }

    //On submit the form
    const onSubmit = (event: any) => {
        event.preventDefault();
        let isValid = checkingErrors(formState.employerId, formState.startDate, formState.endDate);
        const subRoleId = employerList.find((item: any) => item.id === formState.employerId)?.subRoleId;
        if (subRoleId !== undefined || subRoleId !== null) {
            getJobCategories(subRoleId);
        }
        if (isValid) {
            CheckIfReportDataExists(formState.employerId, formState.startDate, formState.endDate, subRoleId);
        }
    };

    //To enable only monday for start date and sunday for end date in calender
    const CustomCalendar = (props: any, showDayInCalednder: any) => {
        const customCell = (props: any) => {
            const isDisabled = !(props.title && props.title.includes(showDayInCalednder));
            return (
                <CalendarCell {...props} isDisabled={isDisabled} />
            )
        }
        return (
            <>
                <Tooltip anchorElement="target" position="top">
                    <Calendar {...props} cell={customCell} />
                </Tooltip>
            </>
        );
    }

    const [showExportPdf, setShowExportPdf] = useState<any>(false);
    const exportPdf = () => {

        let payload: any = {};
        payload.employerId = employerId;
        setShowAverageWeek(true);
        setshowOverview(true);
        setShowWeeklyBreakdown(true);
        ReportService.SaveReportsPdf(payload);
        setTimeout(() => {
            onPdfGenerate();
        }, 1000)
    }

    const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
    const _element = useRef<HTMLDivElement>(null);
    const auth = useAuth();
    const [renderCount, setRenderCount] = useState(0);
    const onExport = async () => {
        document.body.style.overflow = "hidden";
        setShowExportPdf(true);
        await delay(2000);
        exportElement(_element.current, {
            // scale: [0.6, 0.75]
        });
    }

    const onPdfGenerate = () => {
        setShowExportPdf(true);
        onExport();
    }

    const exportElement = async (element: any, options: any) => {
        let group = new Group();
        await delay(200);
        await drawDOM(element, options).then(async (groupDay) => {
            groupDay.options.set('pdf', {
                paperSize: 'auto',
                multiPage: true,
                margin: {
                    left: '1cm',
                    top: '1cm',
                    right: '1cm',
                    bottom: '1cm',
                },
            });
            group.options = groupDay.options;
            group.append(groupDay);
            setRenderCount(1);
            if (group.children.length > 0) {
                pdf.saveAs(group, 'Report-export.pdf');
                document.body.style.overflow = "";
                setShowExportPdf(false);
                setShowWeeklyBreakdown(false);
                setShowAverageWeek(false);
                setRenderCount(0);
            }
        });
    }

    const [employer, setEmployer] = useState<any>("");
    const [employerToggleChecked, setEmployerToggleChecked] = useState<any>(false);
    const [startDate, setStartDate] = useState<any>();
    const [endDate, setEndDate] = useState<any>();

    const renderKeySection = () => {
        return (
            <div className="col-lg-12 px-0">
                <strong className="my-2">Key</strong>
                <div className="row">
                    {validCategoryIds.includes(AppConstants.DCC_Category_Id) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48">
                                    <line x1="4" y1="24" x2="28" y2="24" stroke="#0967B1" strokeWidth="5" strokeDasharray="10,10" />
                                    <circle cx="28" cy="24" r="8" strokeWidth="8" fill="#0967B1" />
                                    <circle cx="28" cy="24" r="4" fill="white" />
                                    <line x1="40" y1="24" x2="60" y2="24" stroke="#0967B1" strokeWidth="5" strokeDasharray="10,10" />
                                </svg>
                                &nbsp; Direct clinical care (DCC)
                            </span>
                        </div>
                    )}
                    {validCategoryIds.includes(AppConstants.ICC_Category_Id) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48">
                                    <line x1="4" y1="24" x2="28" y2="24" stroke="#6F4F9B" strokeWidth="5" strokeDasharray="10,10" />
                                    <rect x="22" y="18" width="12" height="12" fill="white" stroke="#6F4F9B" strokeWidth="3" />
                                    <line x1="40" y1="24" x2="60" y2="24" stroke="#6F4F9B" strokeWidth="5" strokeDasharray="10,10" />
                                </svg>
                                &nbsp; Training and supervision (TS)
                            </span>
                        </div>
                    )}
                    {validCategoryIds.includes(AppConstants.ICC_Category_Id) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48">
                                    <line x1="4" y1="24" x2="44" y2="24" stroke="#DA1F6C" strokeWidth="5" />
                                    <rect x="18" y="18" width="12" height="12" fill="white" stroke="#DA1F6C" strokeWidth="3" />
                                </svg>
                                &nbsp; Indirect clinical care (ICC)
                            </span>
                        </div>
                    )}
                    <div className="col-md-3 mb-3">
                        <span>
                            <svg width="48" height="48">
                                <line x1="4" y1="24" x2="44" y2="24" stroke="#FFDF00" strokeWidth="4" />
                                <circle cx="24" cy="24" r="6" fill="#FFDF00" stroke="#FFDF00" strokeWidth="5" />
                                <circle cx="24" cy="24" r="4" fill="white" />
                            </svg>
                            &nbsp; Worked total
                        </span>
                    </div>
                    {validCategoryIds.includes(AppConstants.CPD_Category_Id) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48">
                                    <line x1="4" y1="24" x2="44" y2="24" stroke="#EA580D" strokeWidth="4" />
                                    <polygon points="24,14 32,34 16,34" fill="white" stroke="#EA580D" strokeWidth="3" />
                                    <line x1="40" y1="24" x2="70" y2="24" stroke="#EA580D" strokeWidth="4" />
                                </svg>
                                &nbsp; Continuous professional development (CPD)
                            </span>
                        </div>
                    )}
                    {
                        userDefinedCategoryName &&
                        (
                            <div className="col-md-3 mb-3">
                                <span>
                                    <svg width="48" height="48">
                                        <line x1="0" y1="24" x2="28" y2="24" stroke="#76A227" strokeWidth="6" strokeDasharray="10,10" />
                                        <polygon points="24,16 30,32 18,32" fill="white" stroke="#76A227" strokeWidth="4" />
                                        <line x1="40" y1="24" x2="70" y2="24" stroke="#76A227" strokeWidth="6" strokeDasharray="10,10" />
                                    </svg>
                                    &nbsp; {userDefinedCategoryName}
                                </span>
                            </div>
                        )
                    }
                    {validCategoryIds.includes(AppConstants.Non_Clinical_Work_Category_Id) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48">
                                    <line x1="2" y1="24" x2="46" y2="24" stroke="#008E82" strokeWidth="4" />
                                    <line x1="14" y1="14" x2="34" y2="34" stroke="#008E82" strokeWidth="4" />
                                    <line x1="34" y1="14" x2="14" y2="34" stroke="#008E82" strokeWidth="4" />
                                </svg>
                                &nbsp; Non-clinical work (NC)
                            </span>
                        </div>
                    )}
                    {(reportSubRoleId === SubRoleType.SalariedGP || reportSubRoleId === SubRoleType.Academic) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48">
                                    <line x1="4" y1="24" x2="44" y2="24" stroke="grey" strokeWidth="4" />
                                </svg>
                                &nbsp; Contract hours
                            </span>
                        </div>
                    )}
                    {validCategoryIds.includes(AppConstants.Academic_Category_Id) && (
                        <div className="col-md-3 mb-3">
                            <span>
                                <svg width="48" height="48" viewBox="0 0 48 48">
                                    <line x1="4" y1="24" x2="44" y2="24" stroke="black" strokeWidth="4" strokeDasharray="8,8" />
                                    <polyline points="18,34 24,14 30,34" fill="none" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                &nbsp; Academic
                            </span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <> <div className="hero-banner hero-banner--background hero-banner--subpage">
            <div className="container">
                <div className="pt-4 pb-4">
                    <h1 className="mb-0">Reports</h1>
                </div>
                <div className="form-group front-start">
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-lg-6">
                                <label className="front-start  mb-2 control-label">Workplace details<b className="text-danger">*</b></label>
                                <DropDownList
                                    data={employerList}
                                    size="large"
                                    style={{ backgroundColor: 'white' }}
                                    onChange={onEmplyerChange}
                                    value={employerList.find((t: any) => t.id === selectedEmployer.value?.id)}
                                    dataItemKey={'id'}
                                    textField={'employerName'}
                                    name="employerId"
                                />
                                {errorMessages.emplyer && <span className="help-block m-b-none text-danger field-validation-valid">{errorMessages.emplyer}</span>}
                            </div>
                            <div className="col-lg-2">
                                <label className="mt-1 mb-1">Report start date<b className="text-danger">*</b></label>
                                <DatePicker calendar={(props) => CustomCalendar(props, "Monday")} format={"dd/MM/yyyy"} size="large" name="startDate" value={formState.startDate} onChange={onStartDateChange} />
                                {errorMessages.startDate && <span className="help-block m-b-none text-danger field-validation-valid">{errorMessages.startDate}</span>}
                            </div>
                            <div className="col-lg-2 mb-2">
                                <label className="mt-1 mb-1">Report end date<b className="text-danger">*</b></label>
                                <DatePicker calendar={(props) => CustomCalendar(props, "Sunday")} format={"dd/MM/yyyy"} size="large" name="endDate" value={formState.endDate} onChange={onEndDateChange} />
                                {errorMessages.endDate && <span className="help-block m-b-none text-danger field-validation-valid">{errorMessages.endDate}</span>}
                            </div>
                            <div className="col-lg-2 mt-1">
                                <button className="btn btn-primary btn-lg my-4 py-2 " type="submit">Create report</button>
                            </div>
                        </div>
                    </form>
                    {
                        isReportDataExist &&
                        (
                            <>
                                {renderKeySection()}
                                <div className="wrapper">
                                    <div className="mb-3"></div>
                                    <ExpansionPanel
                                        title={titleForOverview}
                                        expanded={showOverview === true}
                                        tabIndex={0}
                                        style={{ borderRadius: '5px' }}
                                        onAction={(event: ExpansionPanelActionEvent) => {
                                            setshowOverview(event.expanded ? false : true);
                                        }}
                                    />
                                    {showOverview && (
                                        <>
                                            <div className="m-3">
                                                <OverView startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} setOverViewData={setOverViewData} />
                                            </div>
                                        </>
                                    )
                                    }
                                    <br />
                                    <ExpansionPanel
                                        title={titleForWeeklyBreakdown}
                                        expanded={showWeeklyBreakdown === true}
                                        tabIndex={0}
                                        style={{ borderRadius: '5px', marginTop: '-15px' }}
                                        onAction={(event: ExpansionPanelActionEvent) => {
                                            setShowWeeklyBreakdown(event.expanded ? false : true);
                                        }}
                                    />
                                    {showWeeklyBreakdown && (
                                        <>
                                            <div className="m-3">
                                                <WeeklyBreakDown startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} setWeeklyBreakDownData={setWeeklyBreakDownData} />
                                            </div>
                                        </>
                                    )
                                    }
                                    <br />
                                    <ExpansionPanel
                                        title={titleForAverageWeek}
                                        expanded={showAverageWeek === true}
                                        tabIndex={0}
                                        style={{ borderRadius: '5px', marginTop: '-15px' }}
                                        onAction={(event: ExpansionPanelActionEvent) => {
                                            setShowAverageWeek(event.expanded ? false : true);
                                        }}
                                    />
                                    {showAverageWeek && (
                                        <>
                                            <div className="m-3">
                                                <AverageWeek startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} setAverageWeekData={setAverageWeekData} />
                                            </div>
                                        </>
                                    )
                                    }
                                    {(dutyOnCallActivityExist || isDutyOnCallCategoryExist) &&
                                        <>
                                            <br />
                                            <ExpansionPanel
                                                title={titleForDutyOnCallPeriods}
                                                expanded={showDutyOnCallPeriods === true}
                                                tabIndex={0}
                                                style={{ borderRadius: '5px', marginTop: '-15px' }}
                                                onAction={(event: ExpansionPanelActionEvent) => {
                                                    setshowDutyOnCallPeriods(event.expanded ? false : true);
                                                }}
                                            />
                                        </>
                                    }
                                    {showDutyOnCallPeriods && (
                                        <>
                                            <div className="m-3">
                                                <DutyOncall startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} dutyOnCallCategoryExist={isDutyOnCallCategoryExist} isOnDutyCategoryExist={dutyOnCallActivityExist} />
                                            </div>
                                        </>
                                    )
                                    }
                                    <br />
                                    <ExpansionPanel
                                        title={titleForSetTargets}
                                        expanded={showSetTargets === true}
                                        tabIndex={0}
                                        style={{ borderRadius: '5px', marginTop: '-15px' }}
                                        onAction={(event: ExpansionPanelActionEvent) => {
                                            setshowSetTargets(event.expanded ? false : true);
                                        }}
                                    />
                                    {showSetTargets && (
                                        <>
                                            <div className="m-3 mb-0">
                                                <SetTarget startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} showExportPdf={showExportPdf} setTargetData={setTargetData} />
                                            </div>
                                        </>
                                    )
                                    }
                                </div>
                                {!EmployerNamePattern.test(employer) &&
                                    (
                                        <>
                                            <br />
                                            <Switch size="small" onLabel={""} offLabel={""} defaultChecked={employerToggleChecked} onChange={(e) => setEmployerToggleChecked(e.value)} />
                                            <label className="form-check-label ms-2">Hide workplace details</label>
                                        </>
                                    )
                                }
                                <div className="col-lg-2 ps-0">
                                    <button className="btn btn-primary mt-3 px-3" type="button" onClick={exportPdf}>Save reports as PDF</button>
                                </div>
                            </>
                        )
                    }
                    {
                        isReportDataNotExist &&
                        (
                            <>
                                <div className="noReportErrorMessage">
                                    <span className="text-dark fs-5">There are no activities in the diary for the workplace details and the date range selected.</span>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
        </div>
            {/* For pdf generation */}
            {
                showExportPdf && (
                    <>
                        <div className="loader-backdrop">
                            <Spinner animation="border" variant="primary" />
                        </div>
                        <div className="card-body mt-4 pdfContent" ref={_element}>
                            <div className="headerForReoprt">
                                <a href="https://www.bma.org.uk/" target="_blank" className="logo">
                                    <img className="logo__image" src="/static/media/bma-logo.ace642990421fd0e115d4c8636ebdda3.svg" alt="British Medical Assocation Logo" />
                                </a>
                            </div>
                            <br />
                            {
                                renderCount == 0 && (
                                    <>
                                        <h1 className="text-dark fw-normal mb-0">Report for: {auth?.getLoggedInUserName()}</h1>
                                        {!employerToggleChecked &&
                                            <div><strong>Workplace details:</strong> {employer}</div>
                                        }
                                        <div><b>Report start date: </b> {moment(startDate).format('DD/MM/yyyy')}</div>
                                        <div><b>Report end date: </b>{moment(endDate).format('DD/MM/yyyy')}</div>

                                        {renderKeySection()}
                                    </>
                                )
                            }
                            <h2>Overview</h2>
                            <OverViewPdf overViewDonutChartData={overViewDonutChartData} />
                            <hr className="pdfChartSeparator" />
                            <h2>Weekly breakdown</h2>
                            {weeklyBreakdownData.weeklyBreakDownDetails.map((data: any, index: any) => (
                                <div key={data.weekCommencing}>
                                    <WeeklyBreakDownPdf data={data} weekIndex={index} totalNumberOfWeeks={weeklyBreakdownData.totalNumberOfWeeks} isPublicHolidayToggleChecked={weeklyBreakdownData.isPublicHolidayToggleChecked} isLeaveToggleChecked={weeklyBreakdownData.isLeaveToggleChecked} />
                                </div>
                            ))}
                            <hr className="pdfChartSeparator" />
                            <h2>Average week</h2>
                            <AverageWeekPdf setAverageWeekData={averageWeekDonutChartData} />
                            {
                                (dutyOnCallActivityExist || isDutyOnCallCategoryExist) &&
                                <>
                                    <hr className="pdfChartSeparator" />
                                    <h2>On-call details</h2>
                                    <DutyOncall startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} dutyOnCallCategoryExist={isDutyOnCallCategoryExist} isOnDutyCategoryExist={dutyOnCallActivityExist} />
                                </>
                            }
                            {
                                anySetTargetExists &&
                                <>
                                    <hr className="pdfChartSeparator" />
                                    <h2>Set targets</h2>
                                    <SetTarget startDate={formState.startDate} endDate={formState.endDate} employerID={formState.employerId} showExportPdf={showExportPdf} setTargetData={setTargetData} />
                                </>
                            }
                        </div>
                    </>
                )
            }
        </>
    )
}